export default __webpack_public_path__ + "3e3581f37c92dc16cabd542753638deb.png";